<template
  ><v-dialog v-model="value" persistent fullscreen :retain-focus="false">
    <v-card class="pa-5">
      <v-form ref="workSampleForm" v-model="formValid">
        <v-toolbar color="primary darken-1" dark dense>
          {{
            this.isEdit
              ? $t("portfolio.WorkSample.editWorkSample")
              : $t("portfolio.WorkSample.addWorkSample")
          }}
          <v-spacer></v-spacer>

          <v-btn icon dark @click="value = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" class="pa-0">
                <div class="d-flex">
                  <v-text-field
                    dense
                    :rules="[
                      value =>
                        (!!value && value.length >= 3) ||
                        $t('portfolio.WorkSample.validation.titleMinLength'),
                      value =>
                        !value ||
                        value.length < 450 ||
                        $t('portfolio.WorkSample.validation.titleMaxLength')
                    ]"
                    v-model="worksample.title"
                    :label="$t('portfolio.WorkSample.fields.title')"
                    :placeholder="$t('portfolio.WorkSample.fields.title')"
                    outlined
                  ></v-text-field>
                  <div class="ms-4">
                    <v-btn
                      icon
                      :title="$t('portfolio.WorkSample.fields.flagged')"
                      @click="worksample.flag = !worksample.flag"
                      :color="worksample.flag ? 'error' : 'primary'"
                    >
                      <v-icon>
                        {{ worksample.flag ? "mdi-flag" : "mdi-flag-outline" }}
                      </v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      :title="$t('portfolio.WorkSample.fields.forAttention')"
                      @click="worksample.forAttention = !worksample.forAttention"
                      :color="worksample.forAttention ? 'warning' : 'primary'"
                    >
                      <v-icon>
                        {{
                          worksample.forAttention ? "mdi-alert-circle" : "mdi-alert-circle-outline"
                        }}
                      </v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" class="pa-0">
                <v-textarea
                  dense
                  rows="2"
                  v-model="worksample.caseDescription"
                  :label="$t('portfolio.WorkSample.fields.caseDescription')"
                  :placeholder="$t('portfolio.WorkSample.fields.caseDescription')"
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="pa-0">
                <custom-html-editor v-model="worksample.description"></custom-html-editor>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12" sm="12">
                <custom-file-uploader v-if="value"
                  ref="uploader"
                  @file-uploaded="onUploaded"
                  locationName="Portfolio"
                ></custom-file-uploader>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" :disabled="!formValid" @click="submitWorkSample">{{
            $t("save")
          }}</v-btn>
          <v-btn color="red" text @click="value = false">{{ $t("cancel") }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog></template
>

<script>
 
import customHtmlEditor from "../../custom-html-editor.vue";
import customFileUploader from "../../custom-file-uploader.vue";

export default {
  components: {
    customHtmlEditor,
    customFileUploader
  },
  data() {
    return {
      isEdit: false,
      formValid: false,
      value: false,
      isLoading: false,
      isMultiline: true,
      worksample: {
        title: "",
        caseDescription: "",
        description: "",
        flag: false,
        forAttention: false,
        files: []
      }
    };
  },
 
  methods: {
    submitWorkSample() {
      this.$refs.workSampleForm.validate();
      if (!this.formValid) {
        return;
      }
      if (this.isEdit) {
        this.axios
          .post("/WorkSample/Update", this.worksample)
          .then(response => {
            this.$emit("success");
          })
          .catch(error => {
            console.error("Error updating work sample:", error);
          });
      } else {
        this.axios
          .post("/WorkSample/Post", this.worksample)
          .then(response => {
            this.$emit("success");
          })
          .catch(error => {
            console.error("Error adding work sample:", error);
          });
      }
      this.value = false;
    },
    clear() {
      this.worksample = {
        title: "",
        caseDescription: "",
        description: "",
        flag: false,
        forAttention: false,
        files: []
      };
    },
    showDialog() {
      this.clear();
      this.isEdit = false;
      this.value = true;
      if (this.$refs.uploader) {
        this.$refs.uploader.instance.reset();
      }
    },

    showDialogEdit(workSample) {
      this.clear();
      this.isEdit = true;
      this.worksample = workSample;
      this.value = true;
      if (this.$refs.uploader) {
        this.$refs.uploader.instance.reset();
      }
    },
    onUploaded(e) {
      const fileRes = JSON.parse(e.request.responseText).data;
      this.worksample.files.push({ fileUrl: fileRes.fileUrl });
    }
  }
};
</script>
